import React, { useState } from 'react';
import './LightboxGrid.scss';
import H2 from '../Fonts/H2/H2';
import Lightbox from 'yet-another-react-lightbox-lite';
import 'yet-another-react-lightbox-lite/styles.css';

const LightboxGrid = ({ data }) => {
    const [index, setIndex] = useState(-1);       // Slide index within current item
    const [slides, setSlides] = useState([]);     // Slides to show in Lightbox

    const handleOpen = (images, startIndex = 0) => {
        const formattedSlides = images.map(img => ({ src: img.image.url }));
        setSlides(formattedSlides);
        setIndex(startIndex);
    };

    return (
        <div className='lightbox-grid'>
            {data.map((item, i) => (
                
                <div key={i} className='lightbox-item' onClick={() => handleOpen(item.images, 0)}>
                    <div className='grid-poster'>
                        <div
                            className='poster'
                            alt='poster'
                            style={{ backgroundImage: `url(${item.images[0].image.url})` }}
                        />
                        <H2 text={item.name} />
                    </div>
                </div>
            ))}

            {index >= 0 && (
                <Lightbox
                    slides={slides}
                    index={index}
                    setIndex={setIndex}
                    onClose={() => setIndex(-1)}
                />
            )}
        </div>
    );
};

export default LightboxGrid;